export default class Auth {
  constructor(config) {
    this._url = config.url;
    this._headers = config.headers;
  }

  _check(res) {
    if (res.status === 201) {
      return res.json();
    } else {
      return Promise.reject("Произошла ошибка");
    }
  }

  register(password, login) {
    return fetch(`${this._url}/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({
        password: password,
        login: login,
      }),
    })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data;
    });
  }

  authorize(password, login) {
    return fetch(`${this._url}/login`, {
      method: "POST",
      headers: this._headers,
      body: JSON.stringify({
        password: password,
        login: login,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.token) {
          localStorage.setItem("jwt", data.token);
          return data;
        } else {
          return data;
        }
      });
  }
  getUserProfile() {
    return fetch(`${this._url}/profile`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }
  getAllUser() {
    return fetch(`${this._url}/user`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }


  changeAdmin(admins, id) {
    return fetch(`${this._url}/${admins}/${id}`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }


  deleteUser(id) {
    return fetch(`${this._url}/delete-user/${id}`, {
      credentials: "include",
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }

  changePassw(id, newPassword) {
    return fetch(`${this._url}/change-password/${id}`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({
        newPassword: newPassword,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }


}






export const vandalAuth = new Auth({
  url: "https://vandalvisionteam-vandalvision-servernew-8cf3.twc1.net/api",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
